<template>
  <div class="content">
    <div class="ttile">
      辅助分割
      <span>
        说明：默认悬浮展示在页面
      </span>
    </div>

    <div class="box">
      <p>选择类型</p>
      <SelectType v-model="curComponent.type" />
    </div>

    <div class="box">
      <p>样式基础设置</p>
      <template v-if="curComponent.type === 'space'">
        <SpSlider
          v-model="curComponent.spaceHeight"
          label="空白高度"
          :min="8"
          :max="100"
        />
        <SpPickerColor
          v-model="curComponent.spaceColor"
          :isGradient="true"
          label="背景色"
        />
      </template>

      <template v-else>
        <SpSlider
          v-model="curComponent.lineHeight"
          label="高度"
          :min="8"
          :max="100"
        />
        <SelectLineStyle v-model="curComponent.lineStyle" label="选择样式" />
        <SelectMarginStyle
          v-model="curComponent.marginStyle"
          label="选择样式"
        />
        <SpPickerColor
          v-model="curComponent.lineColor"
          defaultColor="#ffffff"
          label="辅助线颜色"
        />
      </template>
    </div>
  </div>
</template>

<script>
import SelectType from "./components/SelectType";
import SelectLineStyle from "./components/SelectLineStyle";
import SelectMarginStyle from "./components/SelectMarginStyle";

import SpSlider from "../../../components/SpSlider";
import SpPickerColor from "../../../components/SpPickerColor";
export default {
  inject: ["control"],
  components: {
    SpSlider,
    SelectType,
    SpPickerColor,
    SelectLineStyle,
    SelectMarginStyle
  },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }
  > .box {
    padding: 20px 24px;
    > p {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      margin-bottom: 12px;
    }

    /deep/ .select_line_style,
    .slider-content,
    .select_margin_style {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Divider/Attr.vue